/* eslint-disable no-use-before-define */
import { get, set } from '@//data/ionicStorage';
import { EraserShortCuts, PageItemPosition } from '@/types';
// import { Tools } from 'renderer/@corefabriccanvas';

// Kullanıcı modeli
export interface User {
  id: string;
  email: string;
  userGuid: string;
  title: string;
  password: string;
  accessToken: string;
  refreshToken: string;
  isActive: boolean;
  rememberMe: boolean;
  pin?: string;
  isOffline: boolean;
  isAdmin: boolean;
  userSettings: UserSettings;
}

export interface UserSettings {
  userId: string;
  showContentInfo: boolean;
  pageItemPosition: PageItemPosition;
  pageItemIsFull: boolean;
  saveDrawings: boolean;
  continueLastPage: boolean;
  showNextAreaOnPageNavigation: boolean;
  hideIcons: boolean;
  isToolsAutoMoving?: boolean;
  toolBoxSize: number;
  selectedTools: string[];
  eraserShortCut: EraserShortCuts;
  longPressTime: number;
  colors: string[];
  thickness: number[];
}

export const getGuessUser = (): User => {
  const userData: User = {
    userGuid: '0000-0000-0000-0001',
    id: '1',
    email: '',
    title: 'Guess',
    accessToken: '',
    refreshToken: '',
    rememberMe: false,
    pin: '',
    password: '',
    isAdmin: false,
    isOffline: false,
    isActive: true,
    userSettings: defaultUserSettings(),
  };
  return userData;
};

export const getUser = async (): Promise<User> => {

  const users: User[] = (await getAllUsers()) || [];
  if(users.length > 0){
  return users[0];
  } else {
    const user = getGuessUser();
    saveUser(user);
    return user;
  }
};

// Kullanıcı verisi kaydetme
export const saveUser = async (user: User): Promise<User> => {
  try {
    let users: User[] = (await getAllUsers()) || [];
    const existingUser = users.find((x) => x.id === user.id);

   
    if (!user.userSettings) {
      user.userSettings = defaultUserSettings();
    }

    if (existingUser) {
      users = users.map((u) =>
        u.email === user.email ? { ...user, isActive: true } : u,
      );
    } else {
      users.push(user);
    }

    await set('users', users);
    return user;
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

export const saveUserSettings = async (
  userId: string,
  settings: UserSettings,
): Promise<void> => {
  try {
    let users: User[] = (await getAllUsers()) || [];
    const existingUser = users.find((x) => x.id === userId);

    if (existingUser) {
      users = users.map((u) =>
        u.id === userId ? { ...u, userSettings: settings } : u,
      );
    }

    await set('users', users);
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

export const LogoutUser = async (): Promise<void> => {
  const users: User[] = (await getAllUsers()) || [];
  const updatedUsers = users.map((user) => ({ ...user, isActive: false }));
  await set('users', updatedUsers);
};

export const getActiveUser = async (): Promise<User | null> => {
  try {
    const users: User[] = (await getAllUsers()) || [];
    return users.find((x) => x.isActive) || null;
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

export const getAllUsers = async (
  onlyRemembered: boolean = false,
): Promise<User[]> => {
  try {
    let users: User[] = Array.isArray(await get('users')) ? (await get('users') as User[]) : [];
    if (onlyRemembered) {
      users = users.filter((user) => user.rememberMe);
    }
    return users;
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

export const loginOffline = async (
  email: string,
): Promise<User> => {
  try {
    let users: User[] = (await getAllUsers()) || [];
    const existingUser = users.find((x) => x.email === email);
    if (existingUser) {
      users = users.map((user) =>
        user.email === email ? { ...user, isActive: true } : user,
      );
      await set('users', users);
      return existingUser;
    } else {
      return Promise.reject(`${email} hesabı ile daha önce giriş yapılmamış!`);
    }
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

export const removeUser = async (id: string): Promise<void> => {
  try {
    let users: User[] = (await getAllUsers()) || [];
    const existingUser = users.find((x) => x.id === id);

    if (existingUser) {
      users = users.filter((user) => user.id !== id);
      await set('users', users);
    } else {
      return Promise.reject(`Hesap bulunamadı!`);
    }
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

// Varsayılan kullanıcı ayarları
export const defaultUserSettings = (): UserSettings => ({
  userId: '1000-0000-0000-0001',
  showContentInfo: true,
  pageItemPosition: PageItemPosition.left,
  pageItemIsFull: true,
  saveDrawings: true,
  continueLastPage: true,
  showNextAreaOnPageNavigation: true,
  isToolsAutoMoving: false,
  hideIcons: false,
  toolBoxSize: 1,
  selectedTools: ['pan', 'pencil', 'eraser'],
  eraserShortCut: EraserShortCuts.Closed,
  longPressTime: 500,
  colors: ['#000000', '#FF0000', '#0000FF', '#00FF00', '#FFCC00', '#FFC0CB'],
  thickness: [3, 5, 7, 8],
});
